module.exports = __webpack_public_path__ + "static/media/home_schedule.6eb69399.jpg";